import { StateCreator } from 'zustand';
import { Middleware } from './common';

export interface EditJsonDialogSlice {
  editJsonDialog?: EditJsonDialogState;
  openEditJsonDialog: () => void;
  closeEditJsonDialog: () => void;
}

export interface EditJsonDialogState {
  isOpen: boolean;
}

export const createEditJsonDialogSlice: StateCreator<EditJsonDialogSlice, Middleware, [], EditJsonDialogSlice> = (
  set
) => ({
  openEditJsonDialog() {
    set((state) => {
      state.editJsonDialog = {
        isOpen: true,
      };
    });
  },

  closeEditJsonDialog() {
    set((state) => {
      state.editJsonDialog = {
        isOpen: false,
      };
    });
  },
});
